// Fills the compact TestList generator's request: `want` public and hidden cases, generated
// from the same description in separate requests (one per kind, both at once).
//
// For a small task the AI tends to repeat inputs - across the two requests and against the
// list. A case whose input is already present is skipped, so each request asks for a few
// spares, and a kind still short afterwards gets one top-up request. Public is taken first,
// so a repeated input goes to the examples.
//
//   request(count, type)  resolves to the generator's reply ({ unitTests: [...] })
//   existingInputs        inputs already in the list
//   kinds                 [{ label, hidden, want, type }]
// Resolves to the same kinds, each with `cases` (marked hidden true/false) and `failed`
// (its request errored or returned no list).
export const GENERATE_SPARES = 3

export const generateTestCases = async ({ request, existingInputs, kinds }) => {
  const seenInputs = new Set(existingInputs.map((input) => String(input ?? '').trim()))
  const state = kinds.map((kind) => ({ ...kind, cases: [], failed: false }))

  const take = (kind, reply) => {
    for (const test of reply) {
      if (kind.cases.length >= kind.want) return
      const key = String(test?.parameter ?? '').trim()
      if (!test || seenInputs.has(key)) continue
      seenInputs.add(key)
      kind.cases.push({ ...test, hidden: kind.hidden })
    }
  }
  const isShort = (kind) => !kind.failed && kind.cases.length < kind.want

  const requestRound = async () => {
    const short = state.filter(isShort)
    const settled = await Promise.allSettled(
      short.map((kind) => request(kind.want - kind.cases.length + GENERATE_SPARES, kind.type))
    )
    settled.forEach((outcome, n) => {
      if (outcome.status === 'rejected') console.error(outcome.reason)
      const reply =
        outcome.status === 'fulfilled' && Array.isArray(outcome.value?.unitTests) ? outcome.value.unitTests : null
      if (reply) take(short[n], reply)
      else short[n].failed = true
    })
  }

  await requestRound()
  if (state.some(isShort)) await requestRound()
  return state
}
